import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostActivateWaveHeightAlertPayload, PostActivateWaveHeightAlertResponse } from '@/api/waveHeight/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';

export const postActivateWaveHeightAlert = (
    payload: PostActivateWaveHeightAlertPayload
): Promise<PostActivateWaveHeightAlertResponse> => {
    return axios.post('/device/activate-waveheightalert', payload);
};

type UsePostActivateWaveHeightAlertOptions = {
    config?: MutationConfig<typeof postActivateWaveHeightAlert>;
    data?: PostActivateWaveHeightAlertPayload;
};

export const usePostActivateWaveHeightAlert = ({ config }: UsePostActivateWaveHeightAlertOptions = {}) => {
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postActivateWaveHeightAlert,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Wave height alert activated', {
                spotterId: variables.spotterId,
            });
        },
    });
};
